const GET_SAVE_RECEIVING_BRANCH = 'GET_SAVE_RECEIVING_BRANCH'
const SET_SAVE_RECEIVING_BRANCH = 'SET_SAVE_RECEIVING_BRANCH'

export {
    GET_SAVE_RECEIVING_BRANCH,
    SET_SAVE_RECEIVING_BRANCH
}
